import { cmmsPost } from "../cmmsComun";
import certificadoCMMSPdf from "../../../../Pdf/cmms/certificadoCMMSPdf";
import { medirMarcaAgua } from "../../../../Pdf/cmms/comunCMMSPdf";

// docDefinition del PDF de un certificado ya guardado (para ModalPdfCMMS).
export const generarPdfCertificado = async (props, id) => {
    const res = await cmmsPost(props, "datosCertificadoPdfCMMS", { id });
    if (res.data.success !== 2) throw new Error(res.data.message || "No se pudieron consultar los datos del certificado");
    return certificadoCMMSPdf(await medirMarcaAgua(res.data.datos));
};
